module.exports = __webpack_public_path__ + "media/images/top/cost/cost-image1-eabfd30ea5284e97b442995dac0dc6e6.png";